var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1031.33 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#1d1d1b;}.cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.12,247.73c12,0,24.18.47,36.2.73,9.69.2,28,2.35,28.64-8,.35-5.45-3.87-8.95-2.57-15.43,1.38-6.87,17.33-13.84,4.8-22.82-4.32-3.1-8.89-3.88-6.62-11.11,6.89-3.44,16.74,4.85,18.64-7.44,1.42-9.2-7.51-14.84-2.49-20.56,4.5-5.12,20.81,3.06,17.69-10-1.58-6.58-24.47-31.89-30.6-40-3.05-4-3.12-3.83-2.52-10.44,2.92-32.66-9.07-59.13-34.22-77.17C84.38,9.21,48.52,2,19.76.14,11.5-.4,1.43.34.15,8.09c-1.35,8.15,6.9,14.59,10,18.74C18.39,37.94,25.6,43.38,30.68,61.91c4.31,15.71-1.81,46.53,14.75,69.52,9.88,13.7,25.17,7.11,24.47,18.17-.41,6.5-12.8,7.4-19.12,23.65-8.36,21.5,14.15,33,8.69,71.06-5.11,14.42-23.95,25.82-23.26,33,.32,3.42,4,6.25,8.19,6.14,4.83-.12,7.54-3.11,9.51-5.51a195.36,195.36,0,0,1,13-14.9l13.26-15.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.92,247.71a44.67,44.67,0,0,0,6.55,8l19.68,22c8.36,10.36,17.31,4.29,17.6-.45-2.38-6-15.6-20-19.29-23.25-6.7-5.82-5-28.14-3.46-36.26,3-15.28,14.74-28.93,7.91-45.12-6.56-15.54-19-16.52-18.85-23.87.08-4.41,3.37-6,7-7,9.72-2.58,13.37-4.81,17.75-10.89,15.31-21.21,9.11-50.22,14.65-69.63,9.27-32.48,33.7-40.23,30.16-53.93C358.78.14,348.76-.37,340.49.19c-44.77,3-92.29,15.51-112.91,55.43-6.71,13-9.44,31.11-7.75,47.88.94,9.35-3.43,9.52-9.61,18.26-5.15,7.27-22.77,24.87-24,32.4-1.84,11.59,14,4.46,18,8.88,5.13,5.61-3.95,11.34-2.5,20.58,2.1,13.29,14.95,3.2,18.62,7.49,2.3,7-2.26,8.11-6.64,11.1-12.49,8.55,3.4,15.93,4.82,22.83,1.35,6.6-2.92,10.31-2.63,15.44.56,10.29,19.08,8.19,28.62,8,12-.27,24.28-.69,36.35-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.34,139.35h-23v46.09H428.53V43.17h61.38c30,0,49.85,19.23,49.85,48.09,0,18.63-8.34,33.26-22.25,41.28l25.43,52.9H505.4Zm-23-32.06h24.43c10.92,0,18.27-6.41,18.27-16s-7.35-16-18.27-16H462.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.81,163.8H594.18l-6.95,21.64H551.47L601.13,43.17h39.73l49.65,142.27H654.76Zm-9.74-30.06L621,80.24l-17.08,53.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M862.91,43.17V185.44H829.14V96.27l-29.79,89.17H769l-29.2-87.37v87.37H706V43.17h45.08l33.37,99.39,33.37-99.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M974.73,163.8H921.1l-7,21.64H878.4L928.05,43.17h39.73l49.65,142.27H981.68ZM965,133.74l-17.09-53.5-17.08,53.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.88,211.08h8.82v37.17h-8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M478.09,211.08v37.17H467.72l-12.45-23.5v23.5h-8.82V211.08h10.37l12.45,23.51V211.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.38,219.46h-10.9v28.79h-8.82V219.46H482.77v-8.38h30.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543.83,239.88v8.37H518.05V211.08h25.27v8.38H526.87v6.28h13.85v7.85H526.87v6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M563.86,236.21h-6v12H549V211.08h16c7.83,0,13,5,13,12.57,0,4.87-2.18,8.69-5.81,10.78l6.64,13.82H569.1Zm-6-8.38h6.38c2.85,0,4.77-1.67,4.77-4.18s-1.92-4.19-4.77-4.19h-6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616,211.08v37.17H605.63l-12.45-23.5v23.5h-8.82V211.08h10.38l12.45,23.51V211.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M645.22,242.6h-14l-1.81,5.65h-9.34l13-37.17H643.4l13,37.17H647Zm-2.54-7.85-4.46-14-4.47,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687,218.94l-17,20.94h17v8.37H659.13V240.4l17.07-20.94H659.54v-8.38H687Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M692.49,211.08h8.82v37.17h-8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M706.5,229.67c0-11.52,7.52-19.22,18.78-19.22s18.78,7.7,18.78,19.27-7.52,19.16-18.78,19.16S706.5,241.19,706.5,229.67Zm28.22.05c0-6.39-3.79-10.63-9.44-10.63s-9.44,4.24-9.44,10.58,3.78,10.57,9.44,10.57S734.72,236.05,734.72,229.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M780.9,211.08v37.17H770.52l-12.45-23.5v23.5h-8.82V211.08h10.38l12.45,23.51V211.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M810.11,242.6h-14l-1.81,5.65H785l13-37.17H808.3l13,37.17h-9.34Zm-2.54-7.85-4.46-14-4.46,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M849,239.88v8.37H825.32V211.08h8.82v28.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M880,239.88v8.37H854.22V211.08h25.26v8.38H863v6.28h13.85v7.85H863v6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M896.38,237.15l8.19-1.25c.21,3.24,3.17,5.39,7.16,5.39,3.27,0,5.29-1.47,5.29-3.67,0-1.67-1.19-2.67-3.06-3.08l-7.21-1.73c-6.12-1.47-9.44-5.45-9.44-10.73,0-7,5.91-11.63,14.06-11.63,7.68,0,12.35,4.14,13.69,9.74l-7.88,2.41c-.36-2.72-2.7-4.56-5.86-4.56-3,0-4.93,1.63-4.93,3.72,0,1.57,1.09,2.51,3.37,3.09l7.16,1.83c6.12,1.57,9.18,5.6,9.18,10.68,0,7.07-5.91,11.52-14.52,11.52C902.44,248.88,897,243.91,896.38,237.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M939.08,239.35v8.9h-8.82v-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M959.62,236.21h-6v12h-8.82V211.08h16c7.84,0,13,5,13,12.57,0,4.87-2.18,8.69-5.81,10.78l6.64,13.82h-9.81Zm-6-8.38H960c2.86,0,4.78-1.67,4.78-4.18s-1.92-4.19-4.78-4.19H953.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M987.38,239.35v8.9h-8.82v-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1016.8,239.88v8.37H993.09V211.08h8.82v28.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1031.33,239.35v8.9h-8.82v-8.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIt);
export default __webpack_public_path__ + "static/media/logo_it.3bc06614149b6ea1cdb73c64b4b85eaf.svg";
export { ForwardRef as ReactComponent };